
<template>
	<section>			
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				 <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="ShowExport" icon="el-icon-search">导出</el-button>
				</el-form-item>
                <el-form-item  style="float:right;">
					<el-button size="width:100%; height:100%;"  type="primary" v-on:click="getListData" icon="el-icon-search">查询</el-button>
				</el-form-item>
                <el-form-item>
                <el-select  v-model="filters.TenancyId" clearable filterable placeholder="选择或搜索门店" @change="ChangeList">
                 <el-option
               v-for="item in Shopoptions"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>
                <el-form-item>
					<el-input  v-model="filters.Name"   placeholder="会员姓名"></el-input>
				</el-form-item>	
 				<el-form-item>
					<el-input  v-model="filters.Phone"   placeholder="会员电话"></el-input>
				</el-form-item>	               
				<el-form-item>
					<el-input  v-model="filters.CardNumber"   placeholder="会员卡号"></el-input>
				</el-form-item>	
				<el-form-item>
					<el-input type="number"  v-model="filters.Times"   placeholder="评价次数"></el-input>
				</el-form-item>                               	
				<el-form-item >
                <el-select  v-model="filters.State" clearable filterable placeholder="操作状态"  >
                 <el-option label="默认评价" value="1"> </el-option>
                 <el-option label="会员评价" value="2"></el-option>
                  <el-option label="未评价" value="0"></el-option>                
                   </el-select>	
				</el-form-item>
				<el-form-item  style="float:right;">
                <el-select  v-model="filters.Result" clearable filterable placeholder="评价结果"  >
                 <el-option label="其他评价" value="0"> </el-option>
                 <el-option label="满分评价" value="1"></el-option>                  
                   </el-select>	
				</el-form-item>                
				<!-- <el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getListData" placeholder="维度名称"></el-input>
				</el-form-item> -->
		
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="List" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
    <el-table-column type="expand">
      <template slot-scope="props">
          <el-table :data="props.row.ItemDimension">
          <el-table-column prop="Name" label="维度名称" width="120"  sortable>             
          </el-table-column>
			<el-table-column prop="Type" label="维度类型" width="120" :formatter="formatType" sortable>
			</el-table-column>          
           	<el-table-column prop="Value" label="维度值" width="120"  sortable>
			</el-table-column>	           
           	<el-table-column prop="EvaluateValue" label="评价值" width="120"  sortable>
			</el-table-column>
 			  <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.State=='1'">已评价维度</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未评价维度</el-tag>
                  </div>
                  </template>
			</el-table-column>  			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>            
          </el-table>
		  			<el-col :span="24" class="toolbar">
			<el-tag>当前有{{props.row.ItemDimension.length}}个维度</el-tag>
		    </el-col>
      </template>
    </el-table-column>           
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="ShopName" label="门店名称" width="120" sortable>
			</el-table-column>					
			<el-table-column prop="BasicInformationName" label="会员名称" width="120" sortable>
			</el-table-column>
			<el-table-column prop="Phone" label="手机" width="130" sortable>
			</el-table-column>           
 			<el-table-column prop="ComboName" label="套餐名称" width="170"  sortable>
			</el-table-column>	           
			<el-table-column prop="ConsumptionTime" label="消费时间" width="200"  sortable>
			</el-table-column>	
			<el-table-column prop="StudentComment" label="会员评语" width="120" sortable>
			</el-table-column>	             
 			<el-table-column prop="StudentCommentTime" label="评价时间" width="200"  sortable>
			</el-table-column>
			<el-table-column prop="ReplyComment" label="场馆回复" width="120" sortable>
			</el-table-column>	             
 			<el-table-column prop="ReplyTime" label="回复时间" width="200"  sortable>
			</el-table-column> 
  			<el-table-column prop="State" label="操作状态" width="120" sortable>
 				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='1'">默认评价</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.State=='0'">未评价</el-tag>
                   <el-tag type="success" size="medium" v-if="scope.row.State=='2'">会员评价</el-tag>
                  </div>
                  </template>                 
			</el-table-column>   
  			<el-table-column prop="Times" label="评价次数" width="120"  sortable>
 				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="warning" size="medium" v-if="scope.row.Times>0">{{scope.row.Times}}</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.Times==0">{{scope.row.Times}}</el-tag>
                  </div>
                  </template>                   
			</el-table-column>     
  			<el-table-column prop="Result" label="评价结果" width="120"   sortable>
 				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.Result=='1'">满分评价</el-tag>
                  <el-tag type="info" size="medium" v-if="scope.row.Result=='0'">其他评价</el-tag>
                  </div>
                  </template> 		
        	</el-table-column>                                                                            				         
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="openReply(scope.row.Id)">回复</el-button>
					<el-button type="primary" size="small" @click="ShowEditLog(scope.row)">查看评价修改</el-button>
				</template>
			</el-table-column>            
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}个评价记录</el-tag>
			<el-tag>{{AvgValue}}</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="维度名称" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off"></el-input>
				</el-form-item>	                
 				<el-form-item label="维度值" prop="Value">
					<el-input v-model.number="editForm.Value" auto-complete="off"></el-input>
				</el-form-item>               
				<el-form-item label="维度步长" prop="Step">
					<el-input v-model.number="editForm.Step" auto-complete="off"></el-input>
				</el-form-item>					
				<el-form-item label="维度类型" prop="Type">
					<el-radio-group v-model="editForm.Type">
						<el-radio class="radio" :label="1">学员考察维度</el-radio>
						<el-radio class="radio" :label="0">教练考察维度</el-radio>
					</el-radio-group>
				</el-form-item>								
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
				<el-form-item label="维度名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>	                
 				<el-form-item label="维度值" prop="Value">
					<el-input v-model.number="addForm.Value" auto-complete="off"></el-input>
				</el-form-item>               
				<el-form-item label="维度步长" prop="Step">
					<el-input v-model.number="addForm.Step" auto-complete="off"></el-input>
				</el-form-item>					
				<el-form-item label="维度类型" prop="Type">
					<el-radio-group v-model="addForm.Type">
						<el-radio class="radio" :label="1">学员考察维度</el-radio>
						<el-radio class="radio" :label="0">教练考察维度</el-radio>
					</el-radio-group>
				</el-form-item>								
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
        <el-dialog
            title="评价修改记录"
            :visible.sync="visible"
            @close="$emit('update:visible', false)"
            >
            <!-- <el-row >
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
					<el-date-picker type="date" placeholder="延期开始日期" v-model="datetimevalue"></el-date-picker>
				</el-form-item>
                <el-form-item >
					<el-input-number v-model="day" :min="1" :max="20000" placeholder="输入延期天数"></el-input-number>
				</el-form-item>
				<el-form-item >
					<el-input v-model="password" type="password" placeholder="输入操作密码"></el-input>
				</el-form-item>                
				<el-form-item>
					<el-button  type="primary" v-on:click="PostPone" icon="el-icon-search">确认延期</el-button>
				</el-form-item>																	
			</el-form>	
                </el-col>
            </el-row> -->
 		<el-table  :data="EditLogList" highlight-current-row >
    <el-table-column type="expand">
      <template slot-scope="props">
          <el-table :data="props.row.ItemDimension">
          <el-table-column prop="Name" label="维度名称" width="120"  sortable>             
          </el-table-column>
			<el-table-column prop="Type" label="维度类型" width="120" :formatter="formatType" sortable>
			</el-table-column>          
           	<el-table-column prop="Value" label="维度值" width="120"  sortable>
			</el-table-column>	           
           	<el-table-column prop="BeforEvaluateValue" label="修改前评价值" width="160"  sortable>
			</el-table-column>
           	<el-table-column prop="AfterEvaluateValue" label="修改后评价值" width="160"  sortable>
			</el-table-column>			
 			  <!-- <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="success" size="medium" v-if="scope.row.State=='1'">已评价维度</el-tag>
                  <el-tag type="warning" size="medium" v-if="scope.row.State=='0'||scope.row.State==null">未评价维度</el-tag>
                  </div>
                  </template>
			</el-table-column>  			 -->
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>            
          </el-table>
		  			<el-col :span="24" class="toolbar">
			<el-tag>当前有{{props.row.ItemDimension.length}}个维度</el-tag>
		    </el-col>
      </template>
    </el-table-column>     			 
			<el-table-column type="selection" width="55">
			</el-table-column>
            <el-table-column prop="BeforStudentComment" label="修改前评价" width="240" sortable>
			</el-table-column>
            <el-table-column prop="AfterStudentComment" label="修改后评价" width="240"  sortable>
			</el-table-column>            
            <el-table-column prop="StudentCommentTime" label="修改时间" min-width="120"   sortable>
			</el-table-column>            
			<!-- <el-table-column label="操作" width="200" fixed="right">
				<template  slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">查看维度值</el-button>
				</template>
			</el-table-column> -->
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前共{{EditLogCount}}条记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChangeLog" :page-size="10" :total="Edittotal" style="float:right;">
			</el-pagination>
		</el-col>           
        </el-dialog>
		<el-dialog title="回复"
            :visible.sync="replyvisible"
            @close="$emit('update:replyvisible', false)">
            <el-row >
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
					<el-form>
				<el-form-item>
					<el-input type="textarea" v-model="replytext" placeholder="请输入回复"></el-input>
				</el-form-item>				              
				<el-form-item>
					<el-button  type="primary" v-on:click="subreply" icon="el-icon-search">确认回复</el-button>
				</el-form-item>																	
			</el-form>	
                </el-col>
            </el-row>			
			</el-dialog>
		<el-dialog title="导出统计"
            :visible.sync="exportVisible"
            @close="$emit('update:exportVisible', false)">
            <el-row >
                <el-col :span="24" class="toolbar" style="padding-bottom: 1px;" >
				<el-form>
				<el-form-item style="float:right;padding-bottom: 2px;">
				<el-button  type="primary" v-on:click="SubExport" icon="el-icon-search">确认导出</el-button>
				</el-form-item>	
				<el-form-item style="float:right;margin-right:5px">
                   <el-date-picker
                        v-model="dateValue" 
						placeholder="请选择时间"
                         type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                   </el-date-picker>
				</el-form-item>				              
																
			    </el-form>	
                </el-col>
            </el-row>			
			</el-dialog>			
  <!-- 重置界面 -->
	</section>
</template>

<script>
	import util from '../../common/js/util'

	//import NProgress from 'nprogress'
	import {ShopSumExport,SumValue,Reply, EvaluateShopEditLogs,getShopInfor,  getEvaluateShopList, removeDimension, addDimension,editDimension ,ChangeDimensionState } from '../../api/api';

	export default {
		data() {
			return {
				         pickerOptions: {
              shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
				exportVisible:false,
				dateValue:'',
				AvgValue:0,
				replytext:'',
				replyvisible:false,
				replyId:'',
                visible:false,
                CurrentLogId:'',
                EditLogpage:0,
                EditLogCount:0,
                Edittotal:0,
                EditLogList:[],
                Shopoptions:[],
				filters: {
					Name: '',
					Phone:'',
                    CardNumber:'',
                    Times:'',
                    State:'',
                    Result:'',
                    TenancyId:''
				},
				fit:'contain',
				coachId:'',
				Count:0,
				List:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
                    ],	
                    		
 					Value: [
                        { required: true, message: '请输入维度值'},
                        { type: 'number', message: '必须为数字值'}
                    ],   
    					Step: [
                        { required: true, message: '请输入维度步长'},
                         { type: 'number', message: '必须为数字值'}
                    ],   
                    
     					Type: [
                        { type:'number',  required: true, message: '请选择维度考察类型'}
                    ],                      
                                        
                                       
				},
				//编辑界面数据
				editForm: {
					id: 0,
					Name: '',
					Value:'',
					Step:'',
					Remark:'',
					Type:'',
				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
                    ],	
                    		
 					Value: [
                        { required: true, message: '请输入维度值'},
                        { type: 'number', message: '必须为数字值'}
                    ],   
    					Step: [
                        { required: true, message: '请输入维度步长' },
                         { type: 'number', message: '必须为数字值'}
                    ],   
                    
                    
     					Type: [
                        { type:'number',  required: true, message: '请选择维度考察类型'}
                    ],                      
                                              
                    
				},
				//新增界面数据
				addForm: {
					Name: '',
					Value:5,
					Step:1,
					Remark:'',
					Type:1,
				}
			}
		},
		methods: {
		SubExport(){
               if(this.dateValue.length<1)
                {
                         this.$message({
							message: "请先选择时间",
							type: 'error'
                        });                   
                    return;
                }
              //  this.listLoading=true;
				let Params = {
                    StartDate:this.dateValue[0],
                    EndDate:this.dateValue[1],
                    TenancyId:this.filters.TenancyId
				};			
				// this.logLoading	=true;  
				  ShopSumExport(Params).then((res) => {
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = "门店分值统计"; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
		ShowExport()
			{
				this.exportVisible=true;
				this.dateValue='';
			},
		ChangeList()
         {
             
              this.GetSumValue();           
         }, 
			GetSumValue(){				
            let para={TenancyId:this.filters.TenancyId}
            SumValue(para).then((res) => { 
				this.AvgValue=res.data.Data;                 
                 console.log(res);
												}).catch(error=>{
                 alert('网络错误');
                });  				
			},			
		openReply(value){
				 this.replyId=value;			
				 this.replyvisible=true;	 
			},
		subreply()
			{
            let para={text:this.replytext,id:this.replyId}
            Reply(para).then((res) => {                  
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});this.replyvisible=false;									
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});}
												}).catch(error=>{
                 alert('网络错误');
                });            
			},
        ShowEditLog(row){
            this.visible=true; 
            this.CurrentLogId=row.Id; 
            this.getEditLog();						                
         },
         getEditLog()
         {
				let para = {
					PageIndex: this.EditLogpage-1,					
                    PageSize:10,
                    EvaluateId:this.CurrentLogId
				};
            EvaluateShopEditLogs(para).then((res) => {                  
					this.Edittotal = res.data.TotleCount;
					this.EditLogList =res.data.Data;
                    this.EditLogCount=res.data.TotleCount;                        
				})
				 .catch(error=>{
                 alert('网络错误');
                }); 
         },
       getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.Shopoptions = res.data;       
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        },
            
            formatResult: function (row, column) {
				return row.Result == 1 ? '其他评价' : row.State == 0 ? '满分评价' : '未知';
			},            
            formatState: function (row, column) {
				return row.State == 0 ? '未评价' : row.State == 1 ? '默认评价' : row.State == 2 ?'会员评价':'未知';
			},
 			formatType: function (row, column) {
				return row.Type == 1 ? '学员考察维度' :  '教练考察维度' ;
			},           
		Change(row,index)
			{
				let para={
						id:index,				
				}
              ChangeDimensionState(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
									row.State=res.data.Data;
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '状态变更失败',
					    type: 'error'
					 });	
				});
			},            
						//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			// formatType: function (row, column) {
			// 	return row.Type == 1 ? '学员考察维度' :  '教练考察维度' ;
			// },

			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			// formatState: function (row, column) {
			// 	return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			// },
			//性别显示转换
			handleCurrentChange(val) {
				this.page = val;
				this.getListData();
			},
			handleCurrentChangeLog(val) {
				this.EditLogpage = val;
				this.getEditLog();
			},
			getListData() {
				// this.getCount();
				let para = {
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					Phone:this.filters.Phone,
                    CardNumber:this.filters.CardNumber,
                    Times:this.filters.Times,
                    State:this.filters.State,
                    Result:this.filters.Result,
                    TenancyId:this.filters.TenancyId
				};
				this.listLoading = true;
				//NProgress.start();
				getEvaluateShopList(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
	
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					this.total = res.data.TotleCount;
					this.List =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					console.log(res);
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},							
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeDimension(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getListData();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					Name: '',
					Value:5,
					Step:1,
					Remark:'',
					Type:1,				
				};
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {

							this.editLoading = true;
							let para = Object.assign({}, this.editForm);
							editDimension(para).then((res) => {
								this.editLoading = false;
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getListData();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							// if(!(/^1[3456789]\d{9}$/.test(this.addForm.Phone)))
							//  {
                            //     this.$message({
							// 		message: '手机号码不正确',
							// 		type: 'error'
							// 	});
                            //    return ;
							//  }
							this.addLoading = true;
							let para= Object.assign({}, this.addForm);							
							addDimension(para).then((res) => {							
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								this.addLoading = false;
								this.addFormVisible = false;
								this.getListData();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								this.addLoading = false;
								
								}
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},

   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
            this.getListData();
			this.getShopList();
			this.GetSumValue();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
.customWidth{
        width:22%;
    }
.el-dialog {
    position: absolute;
    left: 50%;
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #fff;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    margin-bottom: 50px;
}
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.el-upload-dragger {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 100%;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// EvaluateShop.vue?36107c9c